<template>
  <div class="flex">
    <div class="rsf-table-cell col-12" :class="isNew ? 'flex rsf-table-cell-badge-flex' : ''" :style="isNew ? `justify-content: flex-start; !important;` : ''">
      <NewBadge v-if="isNew" />
      <h3 class="open-sans-regular color-black h5">{{ heading }}</h3>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import NewBadge from "./NewBadge.vue";

export default {
  name: "TableRow",
  components: {
    NewBadge,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
body .rsf-table-cell-badge-flex {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.4rem;
}
@media (max-width: 768px) {
  body .rsf-table-cell-badge-flex {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
}
</style>
